"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/Button.css");
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : Button.js
* Description : Ce fichier contient la définition du composant Button 
*               Ce composant affiche un lien vers une page sous forme de bouton
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* Button : ce lien renvoi une page 
*
* Type : composant 
*
* Parametres : 
*  - children -- texte affiché sur le lien
*  - path -- Url de la page à renvoyer
*/function Button(_ref) {
  var children = _ref.children,
    path = _ref.path;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
      to: path,
      className: "button",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "button-text",
        children: children
      })
    })
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
Button.propTypes = {
  path: _propTypes["default"].string
};
var _default = exports["default"] = Button;